import React, { useState, useEffect } from "react";
import { directoryInfoService } from "../../services/directoryService.service";
import { Link, useHistory } from "react-router-dom";
import ImgRecompensas from "../../assets/imgs/iconos/ico_recompensas.png";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { Button, Tooltip } from "antd";
import {FaCheckCircle, FaStar, FaTimesCircle} from "react-icons/fa";
import Swal from "sweetalert2";

export const ItemDirectory = ({
                                directoryItem,
                                isAdmin,
                                setdirectoryInfoToAuthorize,
                                convertToArray,
                                profileId,
                                sectionOn,
                                updateListP,
                                updateListA,
                                noPost,
                                noDaysGrace,
                                userRegistered
                              }) => {
  const [estrellas, setEstrellas] = useState([0, 0, 0, 0, 0]);
  const [avrText, setAvrText] = useState("0.0");
  const history = useHistory();

  useEffect(() => {
    if (directoryItem.directoryRatings?.length > 0) {
      const ratings = directoryItem.directoryRatings;
      const sum = ratings.reduce((acc, curr) => acc + +curr.score, 0);
      const average = sum / ratings.length;
      setAvrText(average.toFixed(1));

      // Conteo de estrellas por valor
      const starsCount = [1, 2, 3, 4, 5].map(
          (score) => ratings.filter((r) => +r.score === score).length
      );
      setEstrellas(starsCount);
    } else {
      setAvrText("0.0");
      setEstrellas([0, 0, 0, 0, 0]);
    }
  }, [directoryItem.directoryRatings]);

  const approveService = () => {
    Swal.fire({
      title: "¿Desea aprobar esta publicación?",
      text: "No podrás revertir esta acción",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(16, 173, 79)",
      confirmButtonText: "Aprobar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        directoryInfoService
            .approveDirectoryGrace(
                directoryItem.directoryInfoId,
                directoryItem.creatorEmail,
                noPost,
                noDaysGrace
            )
            .then((response) => {
              if (response) {
                Swal.fire({
                  text: "Publicación aceptada exitosamente",
                  icon: "success",
                });
                updateListP();
                updateListA();
              }
            });
      }
    });
  };

  const rejectService = () => {
    Swal.fire({
      title: "¿Desea rechazar esta publicación?",
      text: "No podrás revertir esta acción",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#FF002A",
      confirmButtonText: "Rechazar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        directoryInfoService.rejectDirectory(directoryItem.directoryInfoId).then((response) => {
          if (response) {
            directoryInfoService
                .getAllByCompany(process.env.REACT_APP_COMPANY, 1)
                .then((dataToAuth) => {
                  setdirectoryInfoToAuthorize(convertToArray(dataToAuth));
                  Swal.fire({
                    text: "Publicación rechazada exitosamente",
                    icon: "success",
                  });
                  updateListP();
                });
          }
        });
      }
    });
  };

  return (
      <>
        {isAdmin && directoryItem.directoryInfoStatusName === "En trámite" && (
            <div className="card-directory-admin">
              <Button
                  size="small"
                  type="primary"
                  className="success"
                  onClick={approveService}
                  icon={<FaCheckCircle />}
                  iconPosition={"end"}
              >
                Autorizar
              </Button>
              <Button
                  size="small"
                  className="cancel"
                  type="primary"
                  onClick={rejectService}
                  icon={<FaTimesCircle />}
                  iconPosition={"end"}
              >
                Rechazar
              </Button>
            </div>
        )}
        <div className={`card-directory-main ${isAdmin ? "admin" : ""}`}>
          <div className="card-directory-main-thumbnail">
            {directoryItem.isEnableRewards && (
                <Link to="/Rewards" className="img-rewards">
                  <img
                      src={ImgRecompensas}
                      alt="Este articulo tiene recompensas en PrideMx"
                  />
                </Link>
            )}
            <Splide
                options={{
                  pagination: true,
                  arrows: true,
                  autoplay: true,
                  rewind: true,
                  perMove: 1,
                  perPage: 1,
                  rewindByDrag: true,
                  speed: 900,
                  drag: true,
                }}
            >
              {directoryItem.contactImage?.map((itemImage, index) => (
                  <SplideSlide key={index}>
                    <div className="group-item">
                      <div
                          className="img-item-blur"
                          style={{ backgroundImage: `url(${itemImage})` }}
                      ></div>
                      <img src={itemImage} alt={`${directoryItem.fullName}-${index}`} />
                    </div>
                  </SplideSlide>
              ))}
            </Splide>
          </div>
          <div className="card-directory-main-content">
            <div className="card-directory-main-content-info">
              <Link
                  className="title-link"
                  to={{
                    pathname: sectionOn
                        ? `/register-services/${directoryItem.directoryInfoId}`
                        : `/details-directory/${directoryItem.directoryInfoId}`,
                    state: {
                      Item: directoryItem,
                      profileId,
                      isPay: false,
                    },
                  }}
                  onClick={e => {
                    if (!userRegistered) e.preventDefault();
                  }}
              >
                {directoryItem.fullName?.length > 30
                    ? `${directoryItem.fullName.substring(0, 30)}...`
                    : directoryItem.fullName}
              </Link>
              <div className="text-link">
                {directoryItem.directoryDescription?.length > 120 ? (
                    <>
                      {directoryItem.directoryDescription.substring(0, 120)}...
                      <Link
                          to={{
                            pathname: sectionOn
                                ? `/register-services/${directoryItem.directoryInfoId}`
                                : `/details-directory/${directoryItem.directoryInfoId}`,
                            state: {
                              Item: directoryItem,
                              profileId,
                              isPay: false,
                            },
                          }}
                      >
                        Leer más
                      </Link>
                    </>
                ) : (
                    directoryItem.directoryDescription
                )}
              </div>
            </div>
            <div className="card-directory-main-content-extra">
              {directoryItem.createUserName?.length > 30 ? (
                  <Tooltip placement="topLeft" title={directoryItem.createUserName}>
                    <h6>{directoryItem.createUserName.substring(0, 30)}...</h6>
                  </Tooltip>
              ) : (
                  <h6>{directoryItem.createUserName}</h6>
              )}
              <div className="category">
                <span>{directoryItem.categoryServiceName} </span>
                <span className="badge-directory">{directoryItem.subCategoryServiceName}</span>
              </div>
              <div className="location">
                <Tooltip placement="topLeft" title={directoryItem.location}>
                  <p>
                    {directoryItem.location?.length > 25
                        ? directoryItem.location.substring(0, 25) + "..."
                        : directoryItem.location}
                  </p>
                </Tooltip>
                <p className="ranking">
                  <i><FaStar /></i> {avrText} de 5
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
  );
};
